import { FC, ReactNode } from 'react';

type Props = {
  title: ReactNode;
  children?: ReactNode;
};

const PageHeader: FC<Props> = ({ title, children }) => {
  return (
    <header className='flex flex-row justify-between mb-4'>
      {typeof title === 'string' ? (
        <h1 className="text-4xl font-bold font-['Roboto']">{title}</h1>
      ) : (
        title
      )}
      {children}
    </header>
  );
};

export default PageHeader;
